var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 1H3C2.46957 1 1.96086 1.21071 1.58579 1.58579C1.21071 1.96086 1 2.46957 1 3V18.138C1.00003 18.2256 1.02305 18.3116 1.06676 18.3874C1.11047 18.4633 1.17334 18.5264 1.24907 18.5703C1.32481 18.6143 1.41075 18.6375 1.49831 18.6378C1.58587 18.6381 1.67197 18.6154 1.748 18.572L7.008 15.567C7.31013 15.3944 7.65205 15.3036 8 15.3036C8.34794 15.3036 8.68987 15.3944 8.992 15.567L14.252 18.573C14.3281 18.6165 14.4143 18.6392 14.5019 18.6388C14.5896 18.6385 14.6756 18.6151 14.7514 18.5711C14.8271 18.527 14.89 18.4638 14.9336 18.3878C14.9773 18.3118 15.0001 18.2256 15 18.138V3C15 2.46957 14.7893 1.96086 14.4142 1.58579C14.0391 1.21071 13.5304 1 13 1Z",
    stroke: "#626262",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/save.1740411cbfcff9b1628145452cf9be73.svg";
export { ForwardRef as ReactComponent };